/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Config } from '../config'
import { makeRequest } from '../common/index'

const base_url = Config.admin.api_base_url
const context = Config.admin.context
const endpoint = `/${context}/permission`

/**
 *  getPermissions
 *  @param {string} token
 */
export const getPermissions = async function (token) {
    const method = 'GET'
    const path = `${endpoint}`
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 *  getPermission
 *  @param {string} token
 *  @param {string} guid
 */
export const getPermission = async function (token, guid) {
    const method = 'GET'
    const path = `${endpoint}/${guid}`
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 *  getRolesForPermission
 *  @param {string} token
 *  @param {string} permission
 */
export const getRolesForPermission = async function (token, permission) {
    const method = 'GET'
    const path = `${endpoint}/${permission}/roles`
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 *  getRolesForPermission
 *  @param {string} token
 *  @param {string} permission
 */
export const getRolesForPermissionAll = async function (token, permission) {
    const method = 'GET'
    const path = `${endpoint}/roles`
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 *  createPermission
 *  @param {string} token
 *  @param {Object} payload
 */
export const createPermission = async function (token, payload) {
    const method = 'POST'
    const path = `${endpoint}`
    const headers = {"Authorization": `Bearer ${token}`}
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 *  updatePermission
 *  @param {string} token
 *  @param {string} guid
 *  @param {Object} payload
 */
export const updatePermission = async function (token, guid, payload) {
    const method = 'PUT'
    const path = `${endpoint}/${guid}`
    const headers = {"Authorization": `Bearer ${token}`}
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 *  getImages
 *  @param {string} token
 *  @param {string} guid
 */
export const deletePermission = async function (token, guid) {
    const method = 'DELETE'
    const path = `${endpoint}/${guid}`
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}
